module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-1.53b10928.png";